import { render, staticRenderFns } from "./places.vue?vue&type=template&id=7038ba9b&scoped=true&"
import script from "./places.vue?vue&type=script&lang=js&"
export * from "./places.vue?vue&type=script&lang=js&"
import style0 from "./places.vue?vue&type=style&index=0&id=7038ba9b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7038ba9b",
  null
  
)

export default component.exports